/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicPromptCaching extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicPromptCaching");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicPromptCaching.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicPromptCaching>): BackgroundJobPayloadForPeriodicPromptCaching {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicPromptCaching(), model);
        BackgroundJobPayloadForPeriodicPromptCaching.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicPromptCaching>): BackgroundJobPayloadForPeriodicPromptCaching {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicPromptCaching.newInstance(<BackgroundJobPayloadForPeriodicPromptCaching> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicPromptCaching) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicPromptCaching.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicPromptCaching): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicPromptCaching.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
